import "core-js/stable"
/* eslint no-console:0 */

import moment from 'moment'
moment.locale('lv')

// --- CSS imports
import 'font-awesome/css/font-awesome.css'
import 'react-modal-video/css/modal-video.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-hint/css/index.css'
import 'rc-time-picker/assets/index.css'
// ---

import 'bootstrap'
import '../files/initializers/application'
// Imported after the initializers so app styles override the tinymce skins imported there
import 'stylesheets/application'
import Rails from 'rails-ujs'

Rails.start()
